import * as fromSubUserActions from '../actions/sub-user.actions';
import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {SubUsersResponseModel} from '../../../modules/account/components/sub-user-management/model/sub-users-response.model';
import {SubUserRestService} from '../../../modules/account/components/sub-user-management/service/sub-user.rest-service';

@Injectable()
export class SubUserEffects {
    private actions$ = inject(Actions);
    private subUserRestService = inject(SubUserRestService);

    /**
     * @type {Observable<any[]>}
     */
    loadSubUsers$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromSubUserActions.LoadSubUsers>(
                fromSubUserActions.SubUserActionTypes.LoadSubUsers
            ),
            map(action => action),
            switchMap(() =>
                this.subUserRestService.loadSubUsers().pipe(
                    switchMap(data => [
                        new fromSubUserActions.LoadSubUsersComplete(new SubUsersResponseModel(data.returnObject))
                    ]),
                    catchError(error => of(new fromSubUserActions.LoadSubUsersFailed(error)))
                )
            )
        )
    );

    /**
     * @type {Observable<any[]>}
     */
    initAuthTree$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromSubUserActions.InitAuthTree>(
                fromSubUserActions.SubUserActionTypes.InitAuthTree
            ),
            map(action => action),
            switchMap(() =>
                this.subUserRestService.requestAuthTree().pipe(
                    switchMap(data => [
                        new fromSubUserActions.InitAuthTreeComplete(data.returnObject)
                    ]),
                    catchError(error => of(new fromSubUserActions.InitAuthTreeFailed(error)))
                )
            )
        )
    );

}